import script from "./XImgFade.vue?vue&type=script&setup=true&lang=ts"
export * from "./XImgFade.vue?vue&type=script&setup=true&lang=ts"

import "./XImgFade.vue?vue&type=style&index=0&id=78ead3fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ead3fe"]])

export default __exports__